/* Generated by `npm run marketing:asset:push` — do not edit by hand. */
export const videoChaptersManifest = {
  "product-demo-software-light": [
    {
      "title": "A document and its details",
      "number": 1,
      "startMs": 50067
    },
    {
      "title": "Drafting changes",
      "number": 2,
      "startMs": 132333
    },
    {
      "title": "Review and approval",
      "number": 3,
      "startMs": 237467
    },
    {
      "title": "Teams and access",
      "number": 4,
      "startMs": 320133
    },
    {
      "title": "Approval rules",
      "number": 5,
      "startMs": 365167
    },
    {
      "title": "Shaping work in flight",
      "number": 6,
      "startMs": 466067
    },
    {
      "title": "AI assistants",
      "number": 7,
      "startMs": 510400
    }
  ]
};
